// extracted by mini-css-extract-plugin
module.exports = {"userDashboard":"UserDashboard_userDashboard__2chO9","slide-in-right":"UserDashboard_slide-in-right__3r1Xz","slide-out-right":"UserDashboard_slide-out-right__2YcK8"};